import { render, staticRenderFns } from "./CommunityUsers.vue?vue&type=template&id=39556af3&scoped=true&"
import script from "./CommunityUsers.vue?vue&type=script&lang=ts&"
export * from "./CommunityUsers.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityUsers.vue?vue&type=style&index=0&id=39556af3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39556af3",
  null
  
)

export default component.exports